import { useState } from 'react';

import { CSSProperties } from '@compiled/react';
import { useRive, UseRiveParameters } from '@rive-app/react-canvas';

interface RiveAnimationProps {
	width: CSSProperties['width'];
	height: CSSProperties['height'];
	loadingElement?: JSX.Element | null;
}

export const RiveAnimation = ({
	width,
	height,
	loadingElement = null,
	...rest
}: RiveAnimationProps & UseRiveParameters) => {
	const [isLoading, setIsLoading] = useState(true);
	const { RiveComponent } = useRive({
		...rest,
		autoplay: true,
		onLoad: () => {
			setIsLoading(false);
		},
	});
	return (
		<div style={{ width, height }}>
			{isLoading && loadingElement}
			<RiveComponent />
		</div>
	);
};
